<template>
  <v-col @click="onClick" cols="auto" class="navbar__button pa-0" :class="{ background: state }">
    <slot v-bind="{ ...$props, state, isToolWorking }"> </slot>
  </v-col>
</template>

<script>
import { get, sync } from 'vuex-pathify';

export default {
  name: 'TheNavbarButton',
  props: {
    name: {
      type: String,
      required: true,
    },
    /**
     * A prop describing how tool should behave on click.
     * Default action is to change the URL while custom one is emiting global
     * event composed of name of tool and `-action` suffix.
     * this.$root.$emit(`${this.name}-action`)
     * @type {Boolean}
     */
    hasCustomAction: {
      type: Boolean,
      default: false,
    },
    routeName: {
      type: String,
      default: '',
    },
    routeParams: {
      type: Object,
      default: () => {},
    },
    isRegister: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: null,
    },
    hasState: {
      type: Boolean,
      default: false,
    },
    isToolWorking: {
      type: Boolean,
      default: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    state: false,
  }),
  computed: {
    additionalModules: get('admin/additionalModules'),
    currentTab: sync('sidebar/currentTab'),
    query() {
      return this.$route.query;
    },
    isConfigurated() {
      const additionalModule = this.additionalModules[this.name];
      if (additionalModule) {
        return additionalModule.configured;
      } else {
        return true;
      }
    },
  },
  methods: {
    // default button on click action is to change URL
    handleDefaultAction() {
      if (this.isRegister) {
        this.$router.push({
          name: 'layerTable',
          params: {
            lid: this.name,
          },
        });
        this.$root.$emit('registerOpened');
      } else {
        if ([this.routeName, this.name].includes(this.$route.name) && this.currentTab !== 1) {
          this.currentTab = 1;
        } else {
          this.$router.push({
            name: this.routeName || this.name,
            params: this.routeParams,
          });
        }
      }
    },
    customAction() {
      if (this.hasState) {
        this.state = !this.state;
        if (this.state) {
          this.$root.$emit('deactivateAllTools');
          this.$nextTick(() => {
            this.$root.$emit(`${this.name}-action`, true);
          });
        } else {
          this.$root.$emit(`${this.name}-action`, false);
        }
      } else {
        this.$root.$emit('deactivateAllTools');
        this.$nextTick(() => {
          this.$root.$emit(`${this.name}-action`);
        });
      }
    },
    pushError(message) {
      this.$store.set('snackbar/PUSH_MESSAGE!', {
        message,
        color: '#333333',
        buttonType: 'text',
      });
    },
    onClick() {
      if (this.level === 0) {
        return;
      } else if (!this.isToolWorking) {
        this.pushError(this.$i18n.t('snackbar.toolNotActive'));
        return;
      } else if (!this.isConfigurated && !this.isAdmin) {
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t(`snackbar.modulesNotConfigurate.${this.name}`),
          color: '#333333',
          buttonType: 'text',
        });
        return;
      }
      return this.hasCustomAction ? this.customAction() : this.handleDefaultAction();
    },
    changeState(name, value) {
      if (this.name !== name) {
        return;
      }
      if (value !== undefined) {
        this.state = value;
        return;
      }
      this.state = !this.state;
    },
    clearState(clickedTool) {
      if (this.hasState && this.name !== clickedTool) {
        this.state = false;
      }
    },
  },
  mounted() {
    if (this.hasState) {
      this.$root.$on('changeButtonState', this.changeState);
      this.$once('hook:beforeDestroy', () => {
        this.$off();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.navbar__button {
  &:hover {
    background-color: rgba(235, 235, 235, 0.534);
    cursor: pointer;
  }
}
.background {
  background-color: #e8f0fe !important;
  color: map-get($colors, 'link') !important;
  border-radius: 2px;
}
.disabled {
  cursor: none;
  pointer-events: none;
  background-color: #0000001f !important;
  color: red !important;
  caret-color: #fff !important;
  .v-icon {
    color: map-get($colors, 'font') !important;
  }
  span {
    color: map-get($colors, 'font');
  }
}
</style>
